



































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { IFile, IPolicy } from 'admiral-core';
import { FileApi } from '@/services/FileApi';
import { Util } from '@/utils/Util';
import { TrashIcon, DownloadIcon } from 'vue-feather-icons';

@Component({
  components: {
    TrashIcon,
    DownloadIcon,
  },
})
export default class UploadFiles extends Vue {
  @Prop({ required: false }) policy!: IPolicy;

  @Prop({ required: true }) files!: IFile[];

  @Prop({ required: true }) newUploadedFiles!: File[];

  isDragOver = false;

  onClick() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  onDragOver() {
    this.isDragOver = true;
  }

  onDragLeave() {
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    console.log('onDrop');
    this.isDragOver = false;
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFiles(input.files);
      input.value = '';
    }
  }

  async handleFiles(files: FileList) {
    const fileArray = Array.from(files);
    // // You can upload files here using fetch/axios, etc.
    // this.$emit('files-uploaded', fileArray);

    this.$emit('files-uploaded', [
      ...(this.newUploadedFiles || []),
      ...fileArray.filter(
        (f: File) => !this.newUploadedFiles.some((f2: File) => f2.name === f.name),
      ),
    ]);
  }

  deleteFile(file: File) {
    this.$emit(
      'delete-file',
      this.newUploadedFiles.filter((f: File) => f.name !== file.name),
    );
  }

  deleteExistingFile(file: IFile) {
    this.$emit(
      'delete-existing-file',
      this.files?.filter((f: IFile) => f.id !== file.id),
    );
  }

  async downloadExistingFile(file: IFile) {
    await Util.downloadExistingFile(file);
  }

  async downloadFile(file: File) {
    // download file from new uploaded files without api
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    a.click();
  }

  async openExistingFile(file: IFile) {
    const response = await FileApi.getFile(file.id);
    // create blob from axios response
    const blob = new Blob([response.data], { type: file.mimeType });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  async openFile(file: File) {
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
  }

  formatUploadedAt(file: IFile) {
    return (
      'Am ' +
      Util.formatDateFull(file.createdAt) +
      ' hochgeladen | Dateigröße: ' +
      this.formatFileSize(file.fileSize)
    );
  }

  get sortedFiles() {
    if (!this.files) return [];
    return [...this.files].sort(
      (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );
  }

  formatFileSize(size: number) {
    return Util.formatFileSize(size);
  }
}
